import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { DEEP_PURPLE, EASE_OUT, PURPLE, SILVER } from '../constants';

interface ChampionCardProps {
  name: string;
  badge: string;
  game: string;
  accent: string;
  quote: string;
  delay?: number;
}

export function ChampionCard({ name, badge, game, accent, quote, delay = 0 }: ChampionCardProps) {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <motion.div ref={ref} initial={{ opacity: 0, scale: 0.9 }} animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }} transition={{ duration: 0.5, delay, ease: EASE_OUT }} className='group relative overflow-hidden rounded-2xl' style={{ background: `linear-gradient(180deg, ${PURPLE}90, ${DEEP_PURPLE})`, border: `1px solid ${accent}30` }}>
      {/* Top accent bar */}
      <div className='h-1 w-full' style={{ background: `linear-gradient(90deg, transparent, ${accent}, transparent)` }} />

      <div className='p-6 md:p-8'>
        {/* Badge */}
        <div className='mb-6 flex items-center gap-3'>
          <div>
            <div className='text-xl font-bold uppercase tracking-wide' style={{ fontFamily: 'var(--font-bai)' }}>
              {name}
            </div>
            <div className='text-xs font-bold uppercase tracking-widest' style={{ color: accent, fontFamily: 'var(--font-bai)' }}>
              {badge}
            </div>
          </div>
        </div>

        {/* Game tag */}
        <div className='mb-5 inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold' style={{ background: `${accent}15`, color: accent, border: `1px solid ${accent}30`, fontFamily: 'var(--font-outfit)' }}>
          <span className='size-1.5 rounded-full' style={{ background: accent }} />
          {game}
        </div>

        {/* Quote */}
        <p className='text-sm leading-relaxed' style={{ color: SILVER, fontFamily: 'var(--font-outfit)' }}>
          &ldquo;{quote}&rdquo;
        </p>
      </div>

      {/* Shimmer on hover */}
      <div className='pointer-events-none absolute inset-0 bg-gradient-to-t from-transparent to-white/[0.02] opacity-0 transition-opacity duration-500 group-hover:opacity-100' />
    </motion.div>
  );
}
